import styles from './ellipsisContentColumn.module.scss';

export const EllipsisContentColumn: React.FC<{
  content: React.ReactNode;
  lineClamp: number;
}> = ({ content, lineClamp }) => {
  return (
    <div className={styles.content} style={{ WebkitLineClamp: lineClamp }}>
      {content}
    </div>
  );
};
